import React, {useMemo} from 'react'
import {FormattedMessage} from 'react-intl'
import {Redirect, useLocation} from 'react-router-dom'
import loadable from '@loadable/component'
import {Container, Text, Flex} from '@chakra-ui/react'
import TrackAndTrace from '@parcellab/js-plugin-utils/v5/react'
import useMultiSite from '../../hooks/use-multi-site'
import useOcapiSite from '../../hooks/useOcapiSite'
import HeaderContent from '../../components/header-content'
import {ORDERSTATUS_HREF} from '../../constants'

const PageNotFound = loadable(() => import('../page-not-found'))

const ShipmentTracking = () => {
    const {locale} = useMultiSite()
    const {parcelLabOrderStatusPageEnabled, parcellabUserId: plUserId} = useOcapiSite()
    const location = useLocation()
    const isOrderStatusPage = new RegExp(`${ORDERSTATUS_HREF}$`).test(location?.pathname)
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const hasLangParam = useMemo(() => searchParams.has('lang'), [searchParams])
    const currentPageLang = useMemo(() => locale?.id?.split('-')?.[0], [locale?.id])

    if (isOrderStatusPage && !hasLangParam && currentPageLang) {
        searchParams.set('lang', currentPageLang)

        return (
            <Redirect
                to={{
                    pathname: location.pathname,
                    search: `?${searchParams.toString()}`
                }}
            />
        )
    }

    const options = {
        plUserId,
        show_searchForm: isOrderStatusPage,
        rerouteButton: 'left',
        show_articleList: true,
        use_campaign_banners: true
    }

    if (isOrderStatusPage && !parcelLabOrderStatusPageEnabled) {
        return <PageNotFound />
    }

    return (
        <>
            <HeaderContent />
            {isOrderStatusPage && (
                <Flex flexDirection="column" gap={2} alignItems="center">
                    <Text as="h1" textStyle="Regular 4XLarge">
                        <FormattedMessage
                            defaultMessage="Track your order"
                            id="global.track.order.title"
                        />
                    </Text>
                    <Text textStyle="Regular XLarge">
                        <FormattedMessage
                            defaultMessage="Enter your details to see when your order will arrive at your home"
                            id="global.track.order.info"
                        />
                    </Text>
                </Flex>
            )}
            <Container px={2} data-testid="sf-shipment-tracking">
                <TrackAndTrace options={options} />
            </Container>
        </>
    )
}

export default ShipmentTracking
